// Prefill rules for proposal items (kept out of the component file so
// react-refresh stays happy and the rules are unit-testable).
import type { ServiceType, BudgetItemInput } from "@/hooks/useBudgets";

/** Catalog rows often have hours_min = 0 (BillingSettingsTab used to write 0) — fall back to a sane default. */
export const DEFAULT_ITEM_HOURS = 10;

export function itemFromServiceType(st: ServiceType, fallbackRate: number): BudgetItemInput {
  return {
    service_type_id: st.id,
    title: st.name,
    pricing_mode: "hourly",
    hours: st.hours_min > 0 ? st.hours_min : DEFAULT_ITEM_HOURS,
    hourly_rate: st.default_hourly_rate > 0 ? st.default_hourly_rate : fallbackRate,
    fixed_price: 0,
    monthly_amount: 0,
  };
}

export function blankItem(fallbackRate: number): BudgetItemInput {
  return {
    service_type_id: null,
    title: "",
    pricing_mode: "hourly",
    hours: DEFAULT_ITEM_HOURS,
    hourly_rate: fallbackRate,
    fixed_price: 0,
    monthly_amount: 0,
  };
}

export function blankRecurringItem(): BudgetItemInput {
  return {
    service_type_id: null,
    title: "Mensalidade",
    pricing_mode: "recurring",
    hours: 0,
    hourly_rate: 0,
    fixed_price: 0,
    monthly_amount: 0,
  };
}
